export { TextOverflow } from './text-overflow';
export type { TextOverflowProps } from './text-overflow';
